<template>
  <div>
    <policy-viewer url-name="ip-assistance" :padding="false" index />
    <p class="mb-4">
      To do so, please complete and provide us with the information requested
      here.
    </p>
    <tml-form ref="copyrightForm" form-name="copyright-form">
      <tml-input
        field-name="firstName"
        type="text"
        placeholder="First name"
        :validation-rules="{required: true}"
      />

      <tml-input
        field-name="surname"
        type="text"
        placeholder="Surname"
        :validation-rules="{required: true}"
      />

      <tml-input
        field-name="email"
        type="email"
        placeholder="Email"
        :validation-rules="{required: true, email: true}"
      />

      <tml-input
        field-name="phone"
        type="tel"
        placeholder="Phone Number"
        :validation-rules="{required: true, numeric: true}"
      />

      <tml-input
        field-name="addr1"
        type="text"
        placeholder="Address Line 1"
        :validation-rules="{required: true}"
      />

      <tml-input field-name="addr2" type="text" placeholder="Address Line 2" />

      <tml-textarea
        field-name="claim"
        placeholder-animation="hide"
        placeholder="
          Describe the copyrighted work and/or trademark and how you believe
          this to have been infringed. Please include as much information and
          detail as possible, including references to any documentation/trademarks/licenses
          that are relevant if appropriate
        "
        :custom-style="{height: '300px'}"
        :validation-rules="{required: true}"
      />

      <tml-textarea
        field-name="location"
        placeholder-animation="hide"
        placeholder="
          Please describe where the claimed infringing content is located on the
          Site. URLS should be in the following form: www.teemill.co.uk/category/example
        "
        :custom-style="{height: '300px'}"
        :validation-rules="{required: true}"
      />

      <tml-textarea
        field-name="proof"
        placeholder-animation="hide"
        placeholder="
          Describe to us any proof you have of your ownership of the IP at issue
        "
        :custom-style="{height: '300px'}"
        :validation-rules="{required: true}"
      />

      <tml-textarea
        field-name="process"
        placeholder-animation="hide"
        placeholder="
          Explain the efforts you have made to reconcile your claim with the
          applicable Teemill Store Operator, including the names of the persons
          you have contacted and the outcome thus far of those discussions.
          Please note that if we elect to support you we will only be able to
          assist you in the work you are doing and only insofar as we consider
          our support to be useful and constructive. We are not in position to
          represent you or to independently work to resolve matters on your behalf.
        "
        :custom-style="{height: '300px'}"
        :validation-rules="{required: true}"
      />

      <tml-toggle
        v-model="copyrightHolderToggle"
        label="I am the copyright holder"
        field-name="holder"
        @click="onlyOneSelection(1)"
      />

      <tml-toggle
        v-model="copyrightBehalfToggle"
        label="I am acting on behalf of the copyright holder"
        field-name="behalf"
        @click="onlyOneSelection(2)"
      />

      <tml-button
        fill
        style="margin-bottom: 15px"
        text="Send"
        primary
        :loading="submitLoading"
        @click="send"
      />
    </tml-form>
  </div>
</template>

<script>
import {formatUrl} from '@teemill/common/helpers';
import {PolicyViewer} from '@teemill/modules/policy';

export default {
  name: 'HelpCopyright',

  components: {
    PolicyViewer,
  },

  data() {
    return {
      copyrightHolderToggle: false,
      copyrightBehalfToggle: false,
      submitLoading: false,
      eula: '',
    };
  },

  methods: {
    onlyOneSelection(clicked) {
      if (clicked === 1) {
        this.copyrightBehalfToggle = false;
      } else {
        this.copyrightHolderToggle = false;
      }
    },

    send() {
      if (!this.submitLoading) {
        this.$refs.copyrightForm.validateAll().then(success => {
          if (success) {
            const copyrightFormData =
              this.$store.getters['forms/copyright-form/formData'];
            this.submitLoading = true;

            this.axios
              .post(formatUrl('/omnis/v3/contact/send-ip-contact/'), {
                firstName: copyrightFormData.firstName.value,
                surname: copyrightFormData.surname.value,
                phone: copyrightFormData.phone.value,
                email: copyrightFormData.email.value,
                address1: copyrightFormData.addr1.value,
                address2: copyrightFormData.addr2
                  ? copyrightFormData.addr2.value
                  : null,
                claim: copyrightFormData.claim.value,
                location: copyrightFormData.location.value,
                proof: copyrightFormData.proof.value,
                process: copyrightFormData.process.value,
              })
              .success(() => {
                snackbar('Your copyright infringement claim has been sent');
              })
              .oops()
              .finally(() => {
                this.submitLoading = false;
              });
          }
        });
      }
    },
  },
};
</script>
